'use client';

import { BlockedProvider } from "@/context/BlockedContext";
import { useState, useEffect } from 'react';

export function Providers({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <>{children}</>;
  }

  return (
    <BlockedProvider>
      {children}
    </BlockedProvider>
  );
} 